import React, { Component } from "react";
import Select from "react-select";
import { injectIntl } from "react-intl";

export class LimitedSelected extends Component {
  onChange = nextValues => {
    const { maxSelections = null, onChange } = this.props;
    if (maxSelections && nextValues) {
      if (nextValues.length <= maxSelections) {
        onChange(nextValues);
      }
    } else {
      onChange(nextValues || []);
    }
  };

  colourStyles = {
    control: styles => ({
      ...styles,
      backgroundColor: "white",
      border: "1px solid #aaa",
      height: "auto",
      paddingTop: "4px",
      paddingBottom: "4px"
    }),
    placeholder: styles => ({
      ...styles,
      lineHeight: "40px",
      fontSize: "14px",
      color: "#999"
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        color: "#2c2c2c"
      };
    },
    multiValue: styles => {
      return {
        ...styles,
        backgroundColor: "fff",
        borderBottom: "1px solid #00ada8",
        borderRadius: "0px",
        marginRight: "10px"
      };
    },
    multiValueLabel: styles => ({
      ...styles,
      color: "#000",
      paddingLeft: "0px"
    }),
    multiValueRemove: styles => ({
      ...styles,
      background: "#99d9d7",
      color: "#fff",
      paddingTop: "2px",
      borderRadius: "0px",
      paddingBottom: "1px",
      ":hover": {
        backgroundColor: "#00ada8",
        color: "#fff"
      }
    })
  };

  isGrouped() {
    return this.props.options[0] && this.props.options[0].options !== undefined;
  }

  isObject(item) {
    return typeof item === "object" && !Array.isArray(item) && item !== null;
  }

  getValue() {
    const { options, value } = this.props;

    if (value === "" || value === undefined) return value;

    const values = !Array.isArray(value) ? [value] : value;
    if (values.length === 0) return values;

    return values.map(item => {
      if (this.isObject(item)) return item;

      let option = null;

      if (this.isGrouped()) {
        options.some(
          group =>
            (option = group.options.find(option => option["value"] === item))
        );
      } else {
        option = options.find(option => option["value"] === item);
      }

      return option !== null
        ? option
        : {
            label: value,
            value
          };
    });
  }

  render() {
    const { options, placeholder } = this.props;
    return (
      <Select
        closeMenuOnSelect={false}
        isMulti
        styles={this.colourStyles}
        onInputChange={this.onInputChange}
        onChange={this.onChange}
        options={options}
        placeholder={placeholder}
        hideSelectedOptions={false}
        value={this.getValue()}
      />
    );
  }
}

const LocalizedLimitedSelect = ({
  intl,
  placeholder,
  onChange,
  options,
  value,
  maxSelections
}) => {
  const localizedPlaceholder = intl.formatMessage({ id: placeholder });
  return (
    <LimitedSelected
      onChange={onChange}
      options={options}
      placeholder={localizedPlaceholder}
      value={value}
      maxSelections={maxSelections}
    />
  );
};

export default injectIntl(LocalizedLimitedSelect);



// WEBPACK FOOTER //
// ./src/components/LimitedSelect.js